function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledHeroImageComponent } from "./hero-image-component.scss";
import Dimensions from "constants/dimensions";
import PictureComponent from "components/core/picture/picture-component";
import TextAndAssetComponent from "components/segments/text-and-asset/text-and-asset-component";
class HeroImageComponent extends PureComponent {
    getComponentStyles() {
        const { height } = this.props;
        return {
            height: `calc(${height} - ${Dimensions.TOP_BAR_HEIGHT}px)`
        };
    }
    render() {
        const { halfMoonWidth, textAndAssets, heroImage } = this.props;
        const { src, alt } = heroImage;
        const styles = this.getComponentStyles();
        return /*#__PURE__*/ _jsxs(StyledHeroImageComponent, {
            className: "hero-image-component",
            style: styles,
            children: [
                /*#__PURE__*/ _jsx(PictureComponent, {
                    pictureClass: "hero-image",
                    src: src,
                    alt: alt
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-and-assets-background",
                    style: {
                        left: `calc(-180vh + ${halfMoonWidth})`
                    }
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-and-assets-component-wrapper",
                    children: /*#__PURE__*/ _jsx(TextAndAssetComponent, _object_spread({}, textAndAssets))
                })
            ]
        });
    }
    constructor(props){
        super(props);
    }
}
export { HeroImageComponent as default };
HeroImageComponent.defaultProps = {
    height: "100vh",
    halfMoonWidth: "40vw",
    heroImage: {}
};
